import { buildUrl, sort } from '../../utils/helpers';
import mutationHelpers from '../../utils/mutation-helpers';
import getterHelpers from '../../utils/getter-helpers';
import actionHelpers from '../../utils/action-helpers';
import axios from 'axios';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  nextUrl: null,
  heading: 'Herd Items',
  total: null,
  errors: [],
  filters: {
    condition: [],
    status: []
  },
  conditions: [
    {
      id: 'excellent',
      name: 'Excellent'
    },
    {
      id: 'very good',
      name: 'Very Good'
    },
    {
      id: 'good',
      name: 'Good'
    },
    {
      id: 'fair',
      name: 'Fair'
    },
    {
      id: 'poor',
      name: 'Poor'
    }
  ],
  statuses: [
    {
      id: 'not selling',
      name: 'Not Selling'
    },
    {
      id: 'listed',
      name: 'Listed'
    },
    {
      id: 'pending sale',
      name: 'On Hold'
    },
    {
      id: 'sold',
      name: 'Sold'
    },
    {
      id: 'pending',
      name: 'Pending Purchase'
    }
  ],
  displayStyle: 'grid',
  sorts: [
    {
      direction: 'asc',
      field: 'name',
      active: false,
      label: 'Name'
    },
    {
      direction: 'asc',
      field: 'status',
      active: true,
      label: 'Status'
    },
    {
      direction: 'asc',
      field: 'condition',
      active: false,
      label: 'Condition'
    },
    {
      direction: 'asc',
      field: 'generation_name',
      active: false,
      label: 'Generation'
    },
    {
      direction: 'asc',
      field: 'grouping_name',
      active: false,
      label: 'Grouping'
    }
  ]
};

// getters
const getters = {
  getByHerdId: state => herdId => {
    return state.items.filter(o => {
      return o.herd_id === parseInt(herdId, 10);
    });
  },
  getFilters: state => () => {
    return state.filters;
  },
  getItemById: state => id => {
    return state.items.find(o => {
      return o.id === parseInt(id, 10);
    });
  }
};

// actions
const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  FETCH_ALL: ({ commit, dispatch }, { id, num }) => {
    // fetch an initial list of herd items
    commit('CLEAR_ITEMS');

    const sort = () => {
      const activeSort = state.sorts.filter(o => o.active)[0];

      dispatch('SORT', {
        direction: activeSort.direction,
        field: activeSort.field
      });
    };

    const res = actionHelpers.FETCH_ALL(`${path}/api/user/${id}/herd/items/${num}`, sort)({
      commit,
      dispatch
    });

    console.log('fetch herd items', res);
  },
  FETCH_MORE: ({ commit, dispatch }, payload) => {
    let url = buildUrl(`${state.nextUrl}`, payload);

    actionHelpers.FETCH_MORE(url)({ commit, dispatch });
  },
  FETCH: async ({ commit, dispatch }, payload) => {
    actionHelpers.FETCH(`${path}/api/herd-item/${payload.id}`)(
      { commit, dispatch },
      payload,
      state
    );
  },
  ADD: async ({ commit, dispatch }, payload) => {
    actionHelpers.ADD(`${path}/api/herd-item/create`)(
      { commit, dispatch },
      payload
    );
  },
  UPDATE: async ({ commit, dispatch }, { id, formData }) => {
    actionHelpers.UPDATE(`${path}/api/herd-item/${id}`)(
      { commit, dispatch },
      formData
    );
  },
  REMOVE: async ({ commit, dispatch }, payload) => {
    actionHelpers.REMOVE(`${path}/api/herd-item/${payload.id}`)(
      { commit, dispatch },
      payload
    );
  },
  SET_ERROR: ({ commit }, payload) => {
    commit('SET_ERROR', payload.errors);
  },
  CHANGE_DISPLAY_STYLE: ({ commit }, { display }) => {
    commit('UPDATE_DISPLAY_STYLE', { display });
  },
  SORT: ({ commit }, { direction, field }) => {
    commit('SORT_ITEMS', { direction, field });
  },
  UPDATE_FILTERS: ({ commit, dispatch }, payload) => {
    commit('UPDATE_FILTERS', payload);
    dispatch('FILTER', payload);
  },
  FILTER: async ({ commit, dispatch }, { id, num }) => {
    commit('UPDATE_STATUS', 'loading');

    let url = buildUrl(`${path}/api/user/${id}/herd/items/${num}`, state.filters);

    try {
      const { data } = await axios.get(url);

      commit('UPDATE_STATUS', 'success');
      commit('SET_ITEMS', data);
    } catch (error) {
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch items. try again later.',
        { root: true }
      );
    }
  }
};

const mutations = {
  SORT_ITEMS(state, { direction, field = 'name' }) {
    state.sorts = state.sorts.map(o => {
      if (o.active) {
        o.active = false;
      }

      if (o.field === field) {
        o.direction = direction;
        o.active = true;
      }

      return o;
    });

    if (state.items && state.items.length) {
      state.items = sort([...state.items], direction, field);
    }
  },
  UPDATE_FILTERS: (state, { name, value }) => {
    const filters = { ...state.filters };
    filters[name] = value;

    state.filters = filters;
  }
};

export default {
  namespaced: true,
  state,
  getters: { ...getterHelpers, ...getters },
  actions,
  mutations: { ...mutationHelpers, ...mutations }
};
